import React from "react";
import ConfirmationModal from "./ConfirmationModal.jsx";

export default function DataManagerMissingCivicNumberDialog({
  address = "",
  isOpen = false,
  onCancel = null,
  onConfirm = null,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <ConfirmationModal
      cancelLabel="Non, corriger l'adresse"
      confirmLabel="Oui, continuer"
      description="Cette adresse ne contient pas de numéro civique. La validation sera tout de même effectuée, mais sans exiger de numéro civique."
      eyebrow="Adresse sans numéro civique"
      impactItems={[
        "L'adresse sera géocodée et validée avec des règles assouplies pour l'absence de numéro civique.",
        "Vérifiez que la localité et le nom de rue correspondent bien à la destination réelle.",
      ]}
      onCancel={onCancel}
      onClose={onCancel}
      onConfirm={onConfirm}
      summaryItems={[
        { label: "Adresse saisie", value: address || "—", multiline: true },
      ]}
      summaryLayout="stack"
      title="Sauvegarder sans numéro civique ?"
      warningMessage="Cette adresse n'a pas de numéro civique. Est-ce bien votre volonté de sauvegarder ainsi ?"
    />
  );
}
